// Hardcoded id for the timezone to denote the device timezone of the user
export const DEVICE_TIMEZONE_ID = 1001;
export const INVITEE_TIMEZONE_VARIANT = 36;

export const doesSelectedTimeZoneExists = (selectedTimeZone) => {
  return selectedTimeZone && Object.keys(selectedTimeZone).length !== 0;
};

export const shouldDisplayTimeZone = (selectedTimeZone) => {
  return doesSelectedTimeZoneExists(selectedTimeZone) && selectedTimeZone.value !== DEVICE_TIMEZONE_ID;
};

export const getTimezoneAbbreviation = (selectedTimeZone) => {
  if (!shouldDisplayTimeZone(selectedTimeZone)) {
    return '';
  }
  const { abbreviation } = selectedTimeZone || {};
  return abbreviation && ` ${abbreviation}` || '';
};

/*
 * This function is used to determine the timezone abbreviation for those widgets for which we can determine from
 * the site editor whether to show 'Date, Time, TimeZone' or 'Date, Time', like EventDateTimeWidget and
 * RegistrationDeadlineWidget
 */
export const getTimeZoneForEventTimeWidgets = (eventTimezone, selectedTimeZone, translate) => {
  let timeZone = '';
  if (doesSelectedTimeZoneExists(selectedTimeZone)) {
    timeZone = getTimezoneAbbreviation(selectedTimeZone);
  } else {
    timeZone = translate(eventTimezone.abbreviationResourceKey);
  }
  timeZone = timeZone.trim();
  return timeZone;
};

/*
 * We would send back the selected timezone object if any of the widgets have been selected to show the
 * TimeZoneSwitchWidget from the site editor.  If no widget has been selected, then the timezone feature should not
 * work, and hence the selectedTimeZone object is not returned, thus switching off the feature.
 */
export function getSelectedTimezone(state) {
  if (state.appData.timeZoneSetting && state.appData.timeZoneSetting.displayTimeZone &&
    state.appData.timeZoneSetting.selectedWidgets && state.appData.timeZoneSetting.selectedWidgets.length > 0) {
    return state.selectedTimeZone;
  }
  return undefined;
}

export function convertEventTimezoneTranslations(translate, timezone) {
  if (!timezone) {
    return timezone;
  }
  return {
    ...timezone,
    name: translate(timezone.nameResourceKey),
    abbreviation: translate(timezone.abbreviationResourceKey)
  };
}
